/**
 * Query keys das RESERVAS do app do jogador (`apps/public`).
 *
 * `statusDoPagamento`: a tela "aguardando pagamento" da reserva paga pelo
 * Asaas (11/10/2026 — `booking-checkout-asaas`) acompanha o status da reserva
 * até `confirmed` (o gatilho da baixa confirma) ou `cancelled` (o prazo
 * venceu). Chaveada pela reserva.
 */
import { tuple } from "./core";

const root = ["reservas"] as const;

export const reservas = {
  all: root,
  /** Status + prazo de uma reserva aguardando pagamento (polling). */
  statusDoPagamento: (bookingId: string | null | undefined) => tuple(root, "status-do-pagamento", bookingId),
} as const;
